import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21fb0e12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "footer_link" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "needcursorLink" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "needcursorLinkText",
      href: "https://beian.miit.gov.cn/#/Integrated/index"
    }, "冀ICP备2023037849号-4 | Copyright © 2025 智行优途-管理后台，All rights reserved ")
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    class: "needcursorLinkText",
    href: "https://beian.miit.gov.cn/#/Integrated/index"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_login_panel = _resolveComponent("login-panel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_login_panel),
    _hoisted_2
  ]))
}